import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarItem from '../../components/modal/ModalCadastrarItem';
import ModalEditarItem from '../../components/modal/ModalEditarItem';
import ModalExcluirItem from '../../components/modal/ModalExcluirItem';
import { ServicoContext } from '../../context/ServicoContext';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function Item() {
    const { Success, Error, openModal, setOpenModal, ItensConsulta, ListaItemConsulta, Loading, modalEditarItem, setModalEditarItem, setEdicaoItem, setItemAtualKey, modalExcluirItem, setModalExcluirItem, InativarItem, ListaFiltroItem, totalRegistrosItem, filtroItem, totalRegistrosFiltroItem } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditItem = (props) => {
        setModalEditarItem(true)
        setItemAtualKey(props.key)
        setEdicaoItem(props)
    }

    const DeletarItem = (props) => {
        setItemAtualKey(props.key)
        setModalExcluirItem(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroItem(searchTerm, currentPage, pageSize);
        } else {
            ListaItemConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroItem : totalRegistrosItem;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar itens'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarItem &&
                <ModalEditarItem currentPage={currentPage} />
            }
            {modalExcluirItem &&
                <ModalExcluirItem currentPage={currentPage}  />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {Loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarItem closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar item</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Itens cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroItem : ItensConsulta}
                        columns={[
                            { label: "Nome", field: "descricao", width: "40%", render: (x) => x.descricao || "-"  },
                            { label: "Subgrupo", field: "subgrupo", width: "40%", render: (x) => x?.subGrupo?.descricao || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarItem(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditItem(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarItem(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={Loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroItem(term, 1, 10);
                            } else {
                                ListaItemConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Item;